import React from "react";
import styles from "./TabHeader.module.scss";

export default function TabHeader({
  id,
  className = "",
  showShadow = false,
  children,
  variant = "tab",
  scrollToTop = false,
}) {
  const shadowClass = showShadow ? styles.shadow : "";

  const scrollTop = () => {
    if (scrollToTop) {
      document.getElementById("root").scrollTo({
        top: 0,
        left: 0,
        behavior: "instant",
      });
    }
  };

  return (
    <nav
      onClick={() => scrollTop()}
      id={id}
      className={`nav nav-${variant}s ${styles.container} ${shadowClass} ${className}`}
      role="tablist">
      <div className="row g-0 w-100">{children}</div>
    </nav>
  );
}
